export enum GuaranteedOfferType {
    CreditLimit = 'CreditLimit',
    GuaranteedApr = 'GuaranteeedApr',
    GuaranteedAprAndCreditLimit = 'GuaranteedAprAndCreditLimit',
    GuaranteedCreditLimit = 'GuaranteedCreditLimit',
    MarketingOffer = 'MarketingOffer',
    PreApprovedAndGuaranteedApr = 'PreApprovedAndGuaranteedApr',
    PreApprovedAndGuaranteedCreditLimit = 'PreApprovedAndGuaranteedCreditLimit',
}
